<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div [ngClass]="{'ka-data-grid': !mmSeriousDialogEnable, 'margin-search-result':searchGridMargin, 'employee-access':type === 'empAccess'}"
  *ngIf="defaultColumns.length > 0 && data.length > 0">
  <div class="row" *ngIf="profileCounts" [ngClass]="{'pd-top': profileCounts}">
    <div class="col-md-2 ka-back-search" (click)="navigateToBack()" style="padding: 5px 0 25px 25px">
      <span><i class="fa fa-angle-left" aria-hidden="true"></i></span> Back to Search Page
    </div>
    <div *ngIf="isDisplayNone" class="col-md-2 ka-back-search" (click)="navigateToBack()" style="padding: 5px 0 25px 25px">
      <span><i class="fa fa-angle-left" aria-hidden="true"></i></span> Back to Search Page
    </div>
    <div class="col-md-2"></div>
    <div class="col-md-2"></div>
    <div class="col-md-2"></div>
    <div class="col-md-2"></div>
    <div class="col-md-2"></div>
  </div>
  <div class="ka-em-count-links mb-3">
    <div class="row" *ngIf="profileCounts">
      <div class="col">
        <span class="ka-em-profile-count-label" *ngIf="type!='payment'  && grid2Type!='paymentGrid2'">
          Total Records:<span class="ka-em-profile-counts">{{formValue['TotalRows']}}</span>
        </span>
      </div>
      <div class="col">
        <p class="profile-description">
          Active Count: <span *ngIf="profileCounts.activeCnt>0" class="ka-em-profile-counts"
            (click)="openCountModal('active')"> {{profileCounts.activeCnt}} </span>
          <span *ngIf="profileCounts.activeCnt===0" class="ka-em-profile-counts-zero"> {{profileCounts.activeCnt}}
          </span>
        </p>
      </div>
      <div class="col">
        <p class="profile-description">
          Deleted Count: <span *ngIf="profileCounts.deletedCnt>0" class="ka-em-profile-counts"
            (click)="openCountModal('delete')">{{profileCounts.deletedCnt}}</span>
          <span *ngIf="profileCounts.deletedCnt === 0"
            class="ka-em-profile-counts-zero">{{profileCounts.deletedCnt}}</span>
        </p>
      </div>
      <div class="col">
        <p class="profile-description">
          Settled Count: <span *ngIf="profileCounts.settledCnt>0" class="ka-em-profile-counts"
            (click)="openCountModal('settled')">{{profileCounts.settledCnt}}</span>
          <span *ngIf="profileCounts.settledCnt===0"
            class="ka-em-profile-counts-zero">{{profileCounts.settledCnt}}</span>
        </p>
      </div>
      <div class="col">
        <p class="profile-description">
          Inactive Count: <span *ngIf="profileCounts.inActiveCnt > 0" class="ka-em-profile-counts"
            (click)="openCountModal('inActive')">{{profileCounts.inActiveCnt}}</span>
          <span *ngIf="profileCounts.inActiveCnt === 0"
            class="ka-em-profile-counts-zero">{{profileCounts.inActiveCnt}}</span>
        </p>
      </div>
      <div class="col">
        <p class="profile-description">
          Serious Count: <span *ngIf="profileCounts.sCnt>0" class="ka-em-profile-counts"
            (click)="openCountModal('serious')"> {{profileCounts.sCnt}} </span>
          <span *ngIf="profileCounts.sCnt===0" class="ka-em-profile-counts-zero"> {{profileCounts.sCnt}}
          </span>
        </p>
      </div>
      <div class="col">
        <p class="profile-description">
          MMSerious Count: <span *ngIf="profileCounts.mmsCnt>0" class="ka-em-profile-counts"
            (click)="openCountModal('mmSerious')">{{profileCounts.mmsCnt}}</span>
          <span *ngIf="profileCounts.mmsCnt === 0" class="ka-em-profile-counts-zero">{{profileCounts.mmsCnt}}</span>
        </p>
      </div>

    </div>
    <div class="ka-em-count-links mb-3">
      <div class="row">
        <div class="col-md-2 ka-back-search" (click)="navigateToBack()"
          *ngIf="type==='profileAssign' || type==='search'">
          <span><i class="fa fa-angle-left" aria-hidden="true"></i></span> Back to Search Page
        </div>
      </div>
    </div>

    <div class="row text-center my-2" [ngClass]="type === 'keywordSearch' ? 'keywordSearchHeader' : ''" [ngStyle]="{'padding-top': type !== 'branch' ? '1% !important' : 'unset'}">
      <div class="col-md-2 ka-back-search keyword-navigateBack " (click)="navigateToBack()"
        *ngIf="type == 'keywordSearch'">
        <span><i class="fa fa-angle-left" aria-hidden="true"></i></span><span class="ml-2">Back to Search Page</span>
      </div>
    </div>

      <div class="row text-center my-2" [ngStyle]="{'padding-top': type !== 'branch' ? '1% !important' : 'unset'}">
       <div class="col-md-2"

          *ngIf="type!='payment'  && grid2Type!='paymentGrid2' && type==='profileAssign' || (type==='profileReAssign' && autoMailGrid) || grid2==='duplicateData' || type==='editView'  || type==='com1'|| type==='com2' || type==='com3'  || type==='com4' || type==='paymentAuth' || type==='search' || type =='keywordSearch' || type==='logs' || type==='utm' || type==='empAccess'">
        <div style="padding-top: 6%;">
          <p class="ka-em-profile-count-label">
            Total Records:<span
              *ngIf="type!='payment'  && grid2Type!='paymentGrid2' && type==='profileAssign'  || type==='editView'"
              class="ka-em-profile-counts">{{formValue['TotalRows']}}</span>
            <span *ngIf=" type==='paymentAuth'">{{formValue['TotalRecords']}}</span>
            <span *ngIf="type==='editView' || type==='com1' && formValue || type==='search' || type == 'keywordSearch'"
              class="ka-em-profile-counts">{{formValue['totalRows']}}</span>
            <span *ngIf="type==='com2' && formValue" class="ka-em-profile-counts">{{formValue['totalRows']}}</span>
            <span *ngIf="type==='logs' && formValue" class="ka-em-profile-counts">{{formValue['totalRows']}}</span>
            <span *ngIf="type==='empAccess' && formValue" class="ka-em-profile-counts">{{formValue['TotalRecords']}}</span>
            <span *ngIf="type==='utm' && formValue" class="ka-em-profile-counts">{{formValue['TotalRecords']}}</span>
            <span *ngIf="type==='com3' && formValue" class="ka-em-profile-counts">{{formValue['totalRows']}}</span>
            <span *ngIf="type==='com4' && formValue" class="ka-em-profile-counts">{{formValue['totalRows']}}</span>
            <span *ngIf="grid2==='duplicateData'" class="ka-em-profile-counts">{{data.length}}</span>
            <span *ngIf="type==='profileReAssign' && autoMailGrid" class="ka-em-profile-counts">{{formValue['totalRows']}} </span>
          </p>
        </div>
      </div>
      <div class="col-md-2" *ngIf="type==='profileReAssign'">
        <button mdbBtn class="ka-white-button ka-btn-primary btn-success btn m-auto ka-normalButton-height backToSearch"
        style="width:auto" mdbWavesEffect type="submit" (click)="navigateToBack()">Back to search</button>
      </div>
      <div class="col-md-2" *ngIf="type==='default'"></div>
      <div class="col-md-3" *ngIf="type!='payment'  && grid2Type!='paymentGrid2' && type==='profileAssign' || type==='default' || type==='com1'
        || type==='com2' || type==='com3' || type==='com4' || type==='search' || type == 'keywordSearch' || type==='logs' || type==='utm'">
        <input matInput class="form-control" placeholder="Search" (keyup)="applyFilter($event.target.value)">
      </div>


      <div class="col-md-6" *ngIf="type === 'keywordSearch' && formValue['fromProfileID']">
        <div class="row text-center">
          <div class="col-md-3">
            <span style="font-weight: 700!important;">From Profile ID: </span>
            <span>{{formValue['fromProfileID']}}</span>
          </div>
          <div class="col-md-4 customMultiSelect">
            <p style="font-weight: 700!important;margin: 0;" *ngIf="allSelectedProfiles && allSelectedProfiles.length != null">Selected To Profiles : {{allSelectedProfiles.length}}
            </p>
            <span>{{allSelectedProfiles.join(', ')}}</span>
          </div>

          <div class="col-md-4">
            <button mdbBtn [disabled]="allSelectedProfiles.length <= 0"
              class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 m-auto ka-normalButton-height"
              style="width:auto;margin-top:0px!important" mdbWavesEffect type="submit" (click)="sendServiceFromKeywordSearch()">Send Service</button>
          </div>
        </div>
      </div>
      <div class="col-md-1" *ngIf="type == 'keywordSearch'" style="padding-top: 7px;">
        <span mat-button (click)="exportCSV()" style="cursor: pointer;" matTooltip="Excel Download"><img
            src="../../../../assets/img/profile/excel_ic.svg" alt=""></span>
      </div>
      <div class="col-md-2" *ngIf="type == 'keywordSearch'" style="padding-top: 7px;">
        <button mdbBtn
              class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 m-auto ka-normalButton-height"
              style="width:auto;margin-top:0px!important" mdbWavesEffect type="submit" (click)="printMarketingValues()">Print</button>
        <!-- <a routerLink="/viewProfile" target="_blank" (click)="printMarketingValues()"> Print target</a> -->
      </div>
      <div class="customMultiSelect" [ngClass]="type === 'logs' ? 'col-md-5' : 'col-md-4'" *ngIf="multiSelectItems.length > 0 ">
        <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="multiDropdownSettings" class="col-md-5 m-0 p-0"
          [data]="multiSelectItems" (onSelect)="onItemSelect($event)" [(ngModel)]="selectedItems"
          (onDeSelect)="onItemDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-md-1" *ngIf="type === 'logs'">
      <span mat-button (click)="exportCSV()" style="cursor: pointer;" matTooltip="Excel Download"><img
        src="../../../../assets/img/profile/excel_ic.svg" alt=""></span>
      </div>

      <div class="col-md-2" *ngIf="type==='profileReAssign' && autoMailGrid">
        <div style="padding-top: 1%;">
          <p class="rmdefault">Low Priority Profiles : {{addedProfilesList.length}}
          </p>
        </div>
      <div style="padding-top: 1%;" *ngIf="addtoPriorityProfilesList.length > 0">
          <p class="rmdefault">Added Priority Profiles : {{addtoPriorityProfilesList.length}}
          </p>
      </div>
      </div>

      <div class="col-md-2" *ngIf="type==='profileReAssign' && autoMailGrid">
        <button mdbBtn class="ka-white-button tButton ka-btn-primary btn-success btn m-auto ka-normalButton-height"
        style="width:auto" mdbWavesEffect type="submit" (click)="onSubmitMailPreference()">Submit</button>
      </div>

      <div class="col-md-2" *ngIf="type!='payment' && grid2Type!='paymentGrid2' && type==='profileAssign' ||type==='default'
        || type==='editView' || type==='com1'|| type ==='com2' || type==='com3' || type==='com4'||
        type==='paymentAuth' || type==='search'" style="padding-top: 7px;">
         <span mat-button (click)="exportCSV()" style="cursor: pointer;" matTooltip="Excel Download"><img
            src="../../../../assets/img/profile/excel_ic.svg" alt=""></span>
      </div>
      <div class="col-md-2" *ngIf="search==='advanced' && type==='search'" style="padding-top: 7px;">
        <button mdbBtn
              class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 m-auto ka-normalButton-height"
              style="width:auto;margin-top:0px!important" mdbWavesEffect type="submit" (click)="printMarketingValuesAdv()">Print</button>
    </div>
      <div class="col-md-1" *ngIf="type==='com2' && type1 ==='grid1'" style="padding-top: 7px;">
        <i class="fa fa-file-excel-o ka-icon-excel" (click)="openExportPopup()" matTooltip="Export Records"></i>
      </div>

      <div *ngIf="myProfileGrid" style="padding-top: 7px;" >
        <span mat-button  matTooltip="Slide Show"
        style="cursor: pointer;padding-top: 7px;" (click)="myProfileGridSlideShow()"><img
          src="../../../../assets/img/profile/slideshow_ic.svg" alt=""
         ></span>
      </div>

      <div class="col-md-5 ka-em-paymet-title" *ngIf="type=='payment' && type!='profileAssign'">
        <span style="cursor: pointer;" (click)="navigateToViewProfile()">{{formValue['name']}} </span>
        <span>({{formValue['profileOwner']}}) </span>

      </div>
      <div class="col-md-2" *ngIf="type==='editView' || type==='default'">
        <span *ngIf="type!='payment' &&  grid2Type!='paymentGrid2' && type!='profileAssign' &&  type!='default'"
          style="cursor: pointer;padding-top: 7px;" (click)="playSlideShow()"><img
            src="../../../../assets/img/profile/slideshow_ic.svg" alt=""
            [ngClass]="{ 'ka-em-editView': type==='editView'}"></span>
        <span *ngIf="type==='default'" style="cursor: pointer;padding-top: 7px;"
          (click)="playSlideShowProfileValidation()"><img src="../../../../assets/img/profile/slideshow_ic.svg" alt=""
            [ngClass]="{ 'ka-em-editView': type==='editView'}"></span>
      </div>

      <div class="col-md-1">
        <div *ngIf="type==='payment'" style="padding-top: 26px; text-align: end;">
          <span class="ka-em-payment-actions" *ngIf="formValue['paidAmount'] < formValue['agreedAmount']"
            (click)="navigateToPaymentDetilsPage()">BALANCE</span>
          <span class="ka-em-payment-actions" *ngIf="formValue['paidAmount'] >= formValue['agreedAmount']"
            (click)="renewalTheProfile()">RENEWAL</span>
        </div>
      </div>
      <!-- <div class="col-md-2" *ngIf="type==='payment'" style="text-align: start;padding-top: 2%;">
        <span class="ka-em-payment-actions" style="padding-left: 4%; " *ngIf="formValue['saForm'] != null"
          (click)="viewSAForm()">View SA Form</span>
        <span class="ka-em-payment-no-SAForm" style="padding-left: 10%;" *ngIf="formValue['saForm'] === null">No SA
          Form</span>
      </div> -->
      <!-- <div class="col-md-2" *ngIf="type==='payment'">
        <label class="text-left ka-float-left ka-custom-margin-lable-bottom" for="">Agreed SA</label>
        <input matInput class="form-control" maxlength="8" size="8" (keypress)="omit_specialChar_and_char($event)"
          placeholder="SA" [disabled]="isSAEnabled" [(ngModel)]="SAAmount">
      </div> -->
      <!-- <div class="col-md-2" *ngIf="type==='payment'"
        style="text-align: start; color: #ec273f;padding-top: 30px; cursor: pointer;">
        <span *ngIf="!isSAEnabled" (click)="saveSA()">Save SA</span>
        <span *ngIf="isSAEnabled" (click)="editSA()">Edit SA</span>
      </div> -->
    </div>

    <div class="row text-center" style="padding-top: 1% !important;" [formGroup]="assignProfileOwner"
      *ngIf="type==='profileReAssign' && !autoMailGrid">
      <div class="col-md-2">
        <div style="padding-top: 6%;">
          <p class="ka-em-profile-count-label">Total Records:
            <span class="ka-em-profile-counts">{{formValue['TotalRows']}}</span>
          </p>
        </div>
      </div>

      <div class="col-md-2" *ngIf="type==='profileReAssign'">
        <p class="rmdefault" *ngIf="checkedProfileId && checkedProfileId.length != null">Selected Profiles :{{checkedProfileId.length}}
        </p>
      </div>
      <div class="col-md-3 customMultiSelect" *ngIf="type==='profileReAssign'">
        <p class="rmdefault">Assign profile owner</p>
        <ng-multiselect-dropdown [placeholder]="'Any'" [settings]="dropDownSettings2" [data]="empNameMultiSelectItems"
          (onSelect)="onEmpnameItemSelect($event)" (onDeSelect)="onEmpnameItemDeSelect($event)"
          formControlName="profileOwner">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-md-3 customMultiSelect" *ngIf="type==='profileReAssign'">
        <p class="rmdefault">Assign Secondary profile owner</p>
        <ng-multiselect-dropdown [placeholder]="'Any'" [settings]="dropDownSettings2" [data]="empNameMultiSelectItems"
        (onSelect)="onEmpnameItemSelect($event)" (onDeSelect)="onEmpnameItemDeSelect($event)"
          formControlName="secondprofileOwner">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-md-3" style="text-align: end;">
        <button mdbBtn [disabled]="!assignProfileOwner.valid"
          class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
          style="width:auto" mdbWavesEffect type="submit" (click)="confirmPopup()">Submit</button>
        <button mdbBtn style="width:auto" mdbWavesEffect (click)="resetUnassignSlideData()">Reset</button>
      </div>
    </div>

    <div class="row"
      *ngIf="loginData && loginData['isManagement']=== 1 && loginData['isAdmin'] === 1 && formValue && formValue['paidStatus']===2 && type != 'com2'">
      <div class="col-md-4 ka-em-update-expiry" (click)="showPointsModal(formValue['expiryDate'],formValue)">
        <p>Update Points & Expiry Date</p>
      </div>
    </div>
    <div class="mat-elevation-z8-default" *ngIf="type==='default'" id='default-content'>
      <mat-table #table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter">
        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns;  let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>
            <span *ngIf="col !== 'icon'">{{ getHeader(col) }}</span>
          </mat-header-cell>

          <mat-cell *matCellDef="let element; let j = index" class="ka-em-cell"
            [ngStyle]="{'color':getAssignTicketColour(col,element)}">
            <span style="cursor: pointer;" *ngIf="col !== 'icon' && col==='ProfileID'"
              (click)="onClickRow(element['ProfileID'],col,element)">
              {{getProfileIdWithProfileTypes(col,element)}}
              <i class="far fa-copy" *ngIf="element?.ProfileID"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
                  aria-hidden="true" style="color:black!important;cursor: pointer;"></i>


            </span>
            <span *ngIf="col !== 'icon' && col!='ProfileID'" style="cursor: pointer;"
              (click)="onClickRow(element['ProfileID'],col,element)">{{element[col]}}</span>
            <span *ngIf="col == 'icon'" style="cursor: pointer;">
              <i class="fa fa-play" aria-hidden="true" (click)="openPlayButton(element['ViewfullProfileID'])"></i>

            </span>
            <span *ngIf="col == 'SNO'">{{j+1}}</span>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="defaultColumns ;sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: defaultColumns;"
          [ngStyle]="{'background':changeRowColour(row['ProfileStatusID'])}"></mat-row>
      </mat-table>

      <!-- #modal  -->

    </div>
    <view-ticket-modal [isModalShow]="modalBoolean" [ticketId]="ticketId" (closeTicketModal)="closeTicketModal($event)">
    </view-ticket-modal>

    <div class="mat-elevation-z8-default" *ngIf="type==='branch'" id='default-content'>
      <mat-table #table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter">
        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns;  let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>
            <span *ngIf="col !== 'icon'">{{ getHeader(col) }}</span>
          </mat-header-cell>

          <mat-cell *matCellDef="let element; let j = index" class="ka-em-cell"
            [ngStyle]="{'color':getColor(col,element)}">

            <span *ngIf="col !== 'macAddressName' && col !== 'macAddressName_1' && col !== 'arrivedOn' && col !== 'departingOn' && col !== 'profileID'">{{element[col]}}</span>
            <div *ngIf="col == 'macAddressName'">
              <input type="text" class="form-control" [disabled]="!element?.branchUpdateMode" [(ngModel)]="element[col]">
            </div>
            <div *ngIf="col == 'macAddressName_1'">
              <input type="text" class="form-control" [disabled]="!element?.branchUpdateMode" [(ngModel)]="element[col]">
            </div>
            <span *ngIf="col == 'profileID'" style="cursor: pointer;" [ngStyle]="{'color':getAssignTicketColour('profileID',element)}"
              (click)="navigateToViewProfileByProfileId(element['profileID'],element)">{{getProfileIdWithProfileTypes(col,element)}}

            </span>
            <span *ngIf="col == 'arrivedOn' || col == 'departingOn'">{{element[col] | date: 'dd/MM/yyyy'}}</span>
            <span class="branch-update" (click)="enableBranchIPToUpdate(element)" *ngIf="col === 'update' && !element?.branchUpdateMode">Update</span>
            <span class="branch-update" (click)="updateBranchIP(element)" *ngIf="col === 'update' && element?.branchUpdateMode">Save</span>
            <span class="branch-update" (click)="updateCustomerLeftIndia(element)" *ngIf="col === 'customerUpdate'">Update</span>
            <span class="branch-update" (click)="editBroker(element)" *ngIf="col == 'edit'">
              <i class="fa fa-edit"></i>
            </span>
            <span class="branch-update" (click)="deleteBroker(element)" *ngIf="col == 'delete'">
              <i class="fa fa-trash"></i>
            </span>
            <span *ngIf="col == 'SNO'">{{j+1}}</span>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="defaultColumns ;sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: defaultColumns;"></mat-row>
      </mat-table>

      <!-- #modal  -->

    </div>

    <div class="mat-elevation-z8-default "
      *ngIf="type==='payment' || grid2Type ==='paymentGrid2' || type==='profileAssign' " id='default-content'>
      <mat-table #table matTableExporter [dataSource]="dataSource"
        [ngClass]="{'m-bt': type === 'profileAssign' && data.length === 1}" matSort #exporter="matTableExporter">

        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>
            <p *ngIf="loginData && col==='edit' && loginData['isAdmin']=== 1 && loginData['isManagement'] === 1">
            </p>
            <p *ngIf="col!='edit'">{{ getHeader(col) }}</p>

          </mat-header-cell>
          <cdk-virtual-scroll-viewport itemSize="10" class="viewport">

            <mat-cell *matCellDef="let element" class="ka-em-cell">

              <p *ngIf="col === 'edit' && col != 'description'  && col != 'profileType' && loginData && loginData['isManagement']=== 1 && loginData['isAdmin'] === 1"
                matTooltip="{{element[col]}}" style="color:#ec273f; cursor: pointer;"
                (click)="editedByAdmin(formValue['ProfileID'],element['agreedAmount'],element['paidAmount'],element['description'])">
                Edit</p>
              <p *ngIf="col== 'paymentDate' && col != 'description'  && col != 'profileType' && col != 'edit'"
                matTooltip="{{element[col]}}">{{element[col] | limitTo : '20'}}</p>
              <p *ngIf="col!= 'paymentDate' && col != 'description'  &&
          col != 'profileType' && col != 'ProfileID' && col != 'Marketingticketid' &&
          col != 'assign' && col !='ProfileSecondaryOwnerID' && col != 'ProfileOwnerID' && col != 'edit'"
                matTooltip="{{element[col]}}">
                <span *ngIf="element[col]!=null">{{element[col] | limitTo : '15' }}</span>
                <span *ngIf="element[col]===null">---</span>

              </p>


              <p *ngIf="col == 'ProfileID'">
                <span [ngStyle]="{'color':getAssignTicketColour('ProfileID',element)}"
                  (click)="navigateToViewProfileByProfileId(element['ProfileID'],element)">{{getProfileIdWithProfileTypesAssign(col,element)}}
                  <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
                  aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
                </span><br>
                <span *ngIf="type==='profileAssign'" style="color:#ec273f; cursor: pointer;"
                  (click)="findDuplicate(element['ProfileID'])"
                  [style.color]="selectedIndex===element['ProfileID']?selectedProfileColor:'red'">Find Duplicate</span>
              </p>



              <p *ngIf="col == 'Marketingticketid'">
                <span [ngStyle]="{'color':getColor('Marketingticketid',element)}" style="cursor: pointer;"
                  (click)="onClickRow(element['ProfileID'],col,element)">{{element[col]}}</span>
              </p>


              <span class="ka-em-assignDropdown" *ngIf="col == 'profileType'">
                <ng-multiselect-dropdown [disabled]="element['ServiceType'] == '603' && loginData?.isManagement !== 1 && !loginData?.isConfidential" [placeholder]="'Select'" [settings]="dropDownSettings" class="m-0"
                  [data]="profileTypeArray" [(ngModel)]="element['SelectedServiceType']" (onSelect)="changeProfileType($event, element)"
                  (onDeSelect)="deselectProfileType($event, element)">
                  <!-- (onSelect)="checkAgeStatusAgeBasicTo($event)"
                  (onDeSelect)="deselectProfileType($event, element)"
                  (onSelect)="changeProfileType($event, element)"-->
                  <!-- [disabled]="element['ServiceType'] == '603' && loginData?.isManagement !== 1" -->
                </ng-multiselect-dropdown>
                <!-- <select type="text" class="browser-default custom-select" [(ngModel)]="element['ServiceType']">
                  <option value="null">Select</option>
                  <option *ngFor="let profileType of profileTypeArray" [value]="profileType['id']">
                    <p>{{profileType['name']}}</p>
                  </option>
                </select> -->
              </span>

              <span class="ka-em-assignDropdown" *ngIf="col == 'ProfileOwnerID'" >
                <!-- <select type="text" class="browser-default custom-select" [(ngModel)]="element['ProfileOwnerID']">
                  <option value="null">Select</option>
                  <option *ngFor="let profileOwner of profileOwnerArray" [value]="profileOwner['id']">
                    <p>{{profileOwner['name']}}</p>
                  </option>
                </select> -->
                <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropDownSettings" class="" [disabled]="(element?.setDefaultProfileOwner || element['ServiceType'] == '603') && loginData?.isManagement !== 1 && !loginData?.isConfidential"
                  [data]="profileOwnerArray" [(ngModel)]="element['ProfileOwnerID']" (ngModelChange)="onProfileOwnerChange($event)" (click)="getDataBasedOnServiceType(element['SelectedServiceType'])">
                  <!-- [disabled]="(element?.setDefaultProfileOwner || element['ServiceType'] == '603') && loginData?.isManagement !== 1" -->
                  <!-- (onSelect)="checkAgeStatusAgeBasicTo($event)" -->
                </ng-multiselect-dropdown>
              </span>

              <span class="ka-em-assignDropdown" *ngIf="col == 'ProfileSecondaryOwnerID'  " >
                <ng-multiselect-dropdown [placeholder]="'Select'"
                  [settings]="dropDownSettings" class="" [data]="profileOwnerArray" (ngModelChange)="onSecondaryOwnerChange($event)" (click)="getDataBasedOnServiceType(element['SelectedServiceType'])"
                  [(ngModel)]="element['ProfileSecondaryOwnerID']">
                  <!-- (onSelect)="checkAgeStatusAgeBasicTo($event)" -->
                </ng-multiselect-dropdown>
                <!-- <select *ngIf="element['PaidStatus']===1" type="text" class="browser-default custom-select"
                  [(ngModel)]="element['ProfileSecondaryOwnerID']">
                  <option value="null">Select</option>
                  <option *ngFor="let profileOwner of profileOwnerArray" [value]="profileOwner['id']">
                    <p>{{profileOwner['name']}}</p>
                  </option>
                </select> -->
                <!-- *ngIf="element['PaidStatus']===1" -->
                <!-- <span *ngIf="element['PaidStatus']!=1">---</span> -->
              </span>
              <!-- <p *ngIf="col == 'highConfidential'">
                <mat-checkbox [(ngModel)]="element['isSuperHighConfidential']" [disabled]="!(element?.enableExclusiveGrade || element['exclusiveGrade'] || element['ServiceType'] == '604')">N-Exclusive</mat-checkbox>
              </p> -->
              <p *ngIf="col == 'assign'">
                <span style="color: #ec273f; cursor: pointer;"
                  (click)="assignToOwener(element,element['ProfileID'],element['TicketID'],element['SelectedServiceType'],element['ProfileOwnerID'],element['ProfileSecondaryOwnerID'],element['SelectedProfileOwner'],element['SelectedProfileSecondaryOwner'],element['isSuperHighConfidential'])">Assign</span>
              </p>


              <p *ngIf="col == 'description'">
                <span style="color:#ec273f ;cursor: pointer;" (click)="showDescription(element['description'])">click
                  me</span>

              </p>
            </mat-cell>
          </cdk-virtual-scroll-viewport>
        </ng-container>

        <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: defaultColumns;"></mat-row>

      </mat-table>
      <!-- #modal  -->
      <!-- <view-ticket-modal [isModalShow]="modalBoolean" [ticketId]="ticketId"
        (closeTicketModal)="closeTicketModal($event)">
      </view-ticket-modal> -->
    </div>

    <!-- Edit/View -->

    <div class="mat-elevation-z8-default"
      *ngIf="type==='editView' || type==='com1' || type==='com2' || type==='com3' || type==='com4' || type==='logs' || type==='utm' || type === 'empAccess'"
      id='default-content'>
      <mat-table #table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter">

        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>

            <p *ngIf="col!='displayView'">{{ getHeader(col) }}</p>

          </mat-header-cell>

          <mat-cell *matCellDef="let element; let j = index" class="ka-em-cell">

            <p *ngIf="col=== 'serial'">
              {{j+1}}
              <!-- <span *ngIf="type==='com2' && element['profileStatusID'] != 56"
                style="color: red; cursor: pointer;" (click)="sendComEmail(element)">Photos</span> -->
              <span *ngIf="type==='com2' && element['profileStatusID'] === 56"></span>
              <span *ngIf="type==='com4' && element['MeetingStatus'] === 0"><i class="fa fa-mobile"
                  style="color: #007bff;" aria-hidden="true"></i></span>
              <span *ngIf="type==='com4' && element['MeetingStatus'] === 1"><i class="fa fa-users" style="color: green;"
                  aria-hidden="true"></i></span>
            </p>
            <p *ngIf="col === 'date'">
              <span>{{_convertDate(element['CreatedDate'])}}</span>
            </p>
            <p *ngIf="col=== 'displayView'">
              <i class="fa fa-play" aria-hidden="true" style="cursor: pointer;"
                (click)="openPlayButton(element['profileID'])"></i>
            </p>
            <p *ngIf="col!= 'displayView' && col!= 'profileID' &&  col!='options' && col != 'ticketID' && col !='empName' && col != 'fromticketid' && col != 'toticketid' && col != 'fromProfileid' && col != 'toprofileid' && col != 'fromemp' && col != 'toemp' && col != 'arrivedOn' && col != 'departingOn' && col !== 'EducationGrade' && col !=='format' && col !=='history'"
             style="text-align: left;"  matTooltip="{{element[col]}}">
              <span
                *ngIf="element[col]!=null && col!='genderID' && col!='profileOwner' && col !='profileSecondaryOwner'">{{element[col]
                }}</span>
              <span *ngIf="element[col]!=null && col==='genderID'">{{element[col]===1?'Male':'Female' }}</span>
              <span *ngIf="col==='profileOwner'" style="color: red;">
                <span (click)="getOwnerDetails(element['profileOwnerID'])"
                  style="cursor: pointer;">{{element[col]}}</span>
                <img *ngIf="(element['profileStatusID']===57 || element['profileStatusID']===393) && type==='editView'"
                  (click)="selectedSettlementType(element['custID'],'S')" style="cursor: pointer;"
                  src="../../../../assets/img/editView/settleimage_new.png">
                <img *ngIf="(element['profileStatusID']===56) && type==='editView'"
                  style="cursor: pointer;" (click)="selectedSettlementType(element['custID'],'D')"
                  src="../../../../assets/img/editView/deleteimage.png">
                <img *ngIf="(element['profileStatusID']===394) && type==='editView'"
                  style="cursor: pointer;" (click)="selectedSettlementType(element['custID'],'R')"
                  src="../../../../assets/img/editView/WaitingForDeletion_Img.PNG">

                  <!-- <span  *ngIf="(element['profileStatusID']===394) && type==='editView'"
                   (click)="reactivateProfile(element['profileGrade'],element['custID'],element['profileID'])"
                   style="cursor:pointer;">
                    <i class="fab fa-adn text-primary m-2"></i>
                  </span> -->

                <span *ngIf="element['profileStatusID']===55 && type==='editView'"
                  (click)="selectedSettlementType(element['custID'],'I')"
                  style="font-size: 17px;color: white;font-weight: 600; cursor: pointer;">I?</span>
                <span *ngIf="element['profileStatusID']===395 && type==='editView'"
                  (click)="selectedSettlementType(element['profileID'],'M', element)"
                  style="font-size: 17px;color: white;font-weight: 600; cursor: pointer;">M?</span>
              </span>
              <span *ngIf="element[col]===null">---</span>
            </p>
            <p *ngIf="col!= 'displayView' && col!= 'profileID' &&  col!='options' && col != 'ticketID' && col != 'fromProfileid' && col != 'toticketid' && col !='empName' && col !=='format' && col !=='history'"
              matTooltip="{{element[col]}}">
              <span *ngIf="element[col]!=null && col==='profileSecondaryOwner'" style="color: red;">
                <span (click)="getSecondaryOwnerDetails(element['profileSecondaryOwnerEmpID'])"
                  style="cursor: pointer;">{{element[col]}}</span>
                <img *ngIf="element['profileStatusID']===57 && type==='editView' && element[col]===null"
                  (click)="selectedSettlementType(element['custID'],'S')" style="cursor: pointer;"
                  src="../../../../assets/img/editView/settleimage_new.png">
                <img *ngIf="element['profileStatusID']===56 && type==='editView'  && element[col]===null"
                  style="cursor: pointer;" (click)="selectedSettlementType(element['custID'],'D')"
                  src="../../../../assets/img/editView/deleteimage.png">
                <img *ngIf="element['profileStatusID']===55 && type==='editView'  && element[col]===null"
                  style="cursor: pointer;" (click)="selectedSettlementType(element['custID'],'I')"
                  src="../../../../assets/img/editView/imageInactive.png">
                <span *ngIf="element['profileStatusID']===395 && type==='editView'  && element[col]===null"
                  (click)="selectedSettlementType(element['profileID'],'M')"
                  style="font-size: 17px;color: #d60000;font-weight: 600;">M?</span>
              </span>
            </p>
            <p style="text-align: center;" *ngIf="col === 'EducationGrade'">{{element[col]}}</p>
            <p *ngIf="col === 'empName'" style="color: black;">
              <span>{{element['empName']}}</span> <span>({{element['branchName']}})</span>
            </p>
            <p *ngIf="col == 'arrivedOn' || col == 'departingOn'">
              <span>{{element[col] | date: 'dd/MM/yyyy'}}</span>
            </p>
            <p *ngIf="col === 'fromemp'">
              <span>{{element['fromemp']}}</span><i *ngIf="element['fromServiceFlag'] === 1" class="fa fa-arrow-right marginL"></i>
            </p>
            <p *ngIf="col === 'toemp'">
              <i *ngIf="element['toServiceFlag'] === 1" class="fa fa-arrow-left marginR"></i> <span>{{element['toemp']}}</span>
            </p>
            <p *ngIf="col === 'options'">
              <span style="color: red; cursor: pointer;" (click)="resendComEmail(element, 'RS')">Resend</span><br>
              <span *ngIf="element?.profileStatusID === 54 && (element?.iSRvrSend === 0 || element?.isRvrSend === 0)"
                style="color: red; cursor: pointer;" (click)="resendComEmail(element, 'RVR')">Rvrsend</span>
            </p>
            <p *ngIf="(col === 'ticketID') || (col === 'fromticketid') || (col === 'toticketid')">

              <span *ngIf="col === 'ticketID' && myProfile" style="color: red; cursor: pointer;" (click)="openMarketingTkt(element)">{{element[col]}}

              </span>

              <span *ngIf="col === 'ticketID' && !myProfile" style="color: red; cursor: pointer;" (click)="openCommunicationTicket(element)">{{element[col]}}

              </span>

              <span *ngIf="col === 'fromticketid'" style="color: red; cursor: pointer;" (click)="openCommunicationTicket(element, 'fromticketid')">{{element[col]}}

              </span>

              <span *ngIf="col === 'fromticketid' && element['fromticketid'] === null" (click)="createTicket(element, 'fromticketid')" style="color: #256ee7; cursor: pointer;">Create Ticket

              </span>
              <span *ngIf="col === 'toticketid' && element?.isRvrSend !== 0 && element['toticketid'] === null" (click)="createTicket(element, 'toticketid')" style="color: #256ee7; cursor: pointer;">Create Ticket

              </span>
              <span *ngIf="col === 'toticketid'" style="color: red; cursor: pointer;" (click)="openCommunicationTicket(element, 'toticketid')">{{element[col]}}

              </span>
              <span style="width: 3%;" *ngIf="element['ticketStatusID']===258"><img
                  style="width: 30px;height: 30px; position: initial;transform: translate(-214%, -1%);"
                  src="../../../../assets/img/communication/Red-Cross-Mark-Download.png"></span>
              <span style="width: 3%;" *ngIf="col === 'fromticketid' && element['fromnew']===258"><img
                  style="width: 30px;height: 30px; position: initial;transform: translate(-214%, -1%);"
                  src="../../../../assets/img/communication/Red-Cross-Mark-Download.png"></span>
              <span style="width: 3%;" *ngIf="col === 'toticketid' && element['tonew']===258"><img
                  style="width: 30px;height: 30px; position: initial;transform: translate(-214%, -1%);"
                  src="../../../../assets/img/communication/Red-Cross-Mark-Download.png"></span>
              <span style="width: 3%;" *ngIf="element['mFPEntered'] != 'Emp' && element['mFPStatus']==='I'"><img style="width: 28px;"
                  src="../../../assets/img/communication/Interested_red.png"></span>
              <span style="width: 3%;" *ngIf="col === 'fromticketid' && element['mfpFromEntered'] == 'Customer' && element['fromticketStatusIDb']==='I'"><img style="width: 28px;"
                  src="../../../assets/img/communication/Interested_red.png"></span>
              <span style="width: 3%;" *ngIf="col === 'toticketid' && element['mfpToEntered'] == 'Customer' && element['toticketStatusIDb']==='I'"><img style="width: 28px;"
                  src="../../../assets/img/communication/Interested_red.png"></span>
              <span style="width: 3%;" *ngIf="element['mFPEntered']=='Emp' &&  element['mFPStatus']==='I'"><img
                style="width: 28px;" src="../../../../assets/img/communication/Interested_blue.png"></span>
              <span style="width: 3%;" *ngIf="col === 'fromticketid' && element['mfpFromEntered'] != 'Customer' && element['fromticketStatusIDb'] === 'I'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/Interested_blue.png"></span>
              <span style="width: 3%;" *ngIf="col === 'toticketid' && element['mfpToEntered'] != 'Customer' && element['toticketStatusIDb'] === 'I'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/Interested_blue.png"></span>
              <span style="width: 3%;" *ngIf="element['mFPEntered']!='Emp' && element['mFPStatus']==='NI'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/NotInterested_red.png"></span>
              <span style="width: 3%;" *ngIf="col === 'fromticketid' && element['mfpFromEntered'] == 'Customer' && element['fromticketStatusIDb'] === 'NI'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/NotInterested_red.png"></span>
              <span style="width: 3%;" *ngIf="col === 'toticketid' && element['mfpToEntered'] == 'Customer' && element['toticketStatusIDb'] === 'NI'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/NotInterested_red.png"></span>
              <span style="width: 3%;" *ngIf="element['mFPEntered']=='Emp' &&  element['mFPStatus']==='NI'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/NotInterested_blue.png"></span>
              <span style="width: 3%;" *ngIf="col === 'fromticketid' && element['mfpFromEntered'] != 'Customer' && element['fromticketStatusIDb'] === 'NI'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/NotInterested_blue.png"></span>
              <span style="width: 3%;" *ngIf="col === 'toticketid' && element['mfpToEntered'] != 'Customer' && element['toticketStatusIDb'] === 'NI'"><img
                  style="width: 28px;" src="../../../../assets/img/communication/NotInterested_blue.png"></span>

            </p>
            <p *ngIf="col == 'profileID' && type==='editView' ">
              <span [ngStyle]="{'color':getAssignTicketColour('profileID',element)}" style="cursor: pointer;"
                (click)="navigateToEditViewEducation(element['custID'])">{{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
              </span><br>
            </p>
            <p *ngIf="col == 'profileID' && type!='editView' && !communicationLog">
              <span [ngStyle]="{'color':getAssignTicketColour('profileID',element)}" style="cursor: pointer;"
                (click)="navigateToViewProfileByProfileId(element['profileID'],element)">{{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
              </span><br>
            </p>
            <p *ngIf="col == 'profileID' && type!='editView' && communicationLog && element['ProfileViewAccess'] === 1">
              <span [ngStyle]="{'color':getAssignTicketColour('profileID',element)}" style="cursor: pointer;"
                (click)="navigateToViewProfileByfromAndToCustID(element['fromCustID'], element['toCustID'])" >{{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>

              </span><br>
            </p>
            <p *ngIf="col == 'profileID' && type!='editView' && communicationLog && element['ProfileViewAccess'] === 0">
              <span [ngStyle]="{'color':getAssignTicketColour('profileID',element)}" style="cursor: pointer;"
                matTooltip="Contact RM : {{element['profileOwner']}}">{{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>

              </span><br>
            </p>
            <p *ngIf="col == 'fromProfileid' && type!='editView' && !communicationLog">
              <span [ngStyle]="{'color':getAssignTicketColour('fromPaidStatus',element)}" style="cursor: pointer;" (click)="navigateToViewProfileByProfileId(element['fromProfileid'],element)">
                {{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['fromProfileid'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
              </span> <i (click)="navigateToServiceLog(element['fromProfileid'])" class="fa fa-users" style="color: green;cursor: pointer;"
              aria-hidden="true"></i>
            </p>
            <p *ngIf="col == 'toprofileid' && type!='editView' && !communicationLog">
              <span [ngStyle]="{'color':getAssignTicketColour('toPaidStatus',element)}" style="cursor: pointer;" (click)="navigateToViewProfileByProfileId(element['toprofileid'],element)">
                {{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['toprofileid'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
              </span><i (click)="navigateToServiceLog(element['toprofileid'])" class="fa fa-users" style="color: green;cursor: pointer;"
              aria-hidden="true"></i>
            </p>
            <p *ngIf="col == 'format'" style="display:flex;gap:5px">
              <span class="ka-printed-formats" (click)="openFoneFormat(element)" *ngIf="loginData?.format1" [ngClass]="{'ka-printed-cLog': element['IsFormat1'] == true}">F1</span>
              <span class="ka-printed-formats" (click)="openFtwoFormat(element)" *ngIf="loginData?.format2" [ngClass]="{'ka-printed-cLog': element['IsFormat2'] == true}">F2</span>
              <span class="ka-printed-formats" (click)="openFthreeFormat(element)" *ngIf="loginData?.format3" [ngClass]="{'ka-printed-cLog': element['IsFormat3'] == true}">F3</span>
              <span class="ka-printed-formats" (click)="openFfourFormat(element)" *ngIf="loginData?.format4" [ngClass]="{'ka-printed-cLog': element['IsFormat4'] == true}">F4</span>
            </p>
            <p *ngIf="col == 'history'">
              <span (click)="getFormatHistory(element)" style="cursor: pointer;">Format History</span>
            </p>

            <p *ngIf="col == 'callRecording' && showCallRecordings">
              <span (click)="openCallRecording(element['RecordingURL'])" *ngIf="!(element['RecordingURL'] === null || element['RecordingURL'] === 'None')"><img src="../../../../assets/img/editView/rec_img.JPG" style="height:25px;width:25px" alt=""></span>
              <span *ngIf="(element['RecordingURL'] === null || element['RecordingURL'] === 'None')">---</span>
            </p>
            <p *ngIf="col == 'callRecording' && !showCallRecordings">
              <span> No Access </span>
            </p>
            <p *ngIf="col == 'customerName'">
              <span class="m-1">{{element['CustomerName']}}</span>
            </p>
            <p *ngIf="col == 'employeeName'">
              <span class="m-1">{{element['EmployeeName']}}</span>
            </p>
            <p *ngIf="col == 'callDuration'" class="text-right">
              <span class="m-3">{{element['CallDuration']}}</span>
            </p>
            <p *ngIf="col == 'callDate'">
              <span class="m-1">{{element['CallDate']}}</span>
            </p>
            <p *ngIf="col == 'callReason'">
              <span class="m-1">{{element['CallReason']}}</span>
            </p>
            <p *ngIf="col == 'ProfileId'">
              <span [ngStyle]="{'color':getAssignTicketColour('ProfileID',element)}" class="m-1" style="cursor: pointer;"
                (click)="navigateToViewProfileByProfileId(element['ProfileID'],element)">{{getProfileIdWithProfileTypes('ProfileID',element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
              </span>
            </p>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
        <div>
          <mat-row *matRowDef="let row; columns: defaultColumns;"
            [ngStyle]="{'background':changeRowColourEditView(row['profileStatusID'],row['ticketStatusID'],row['fromFollowUp'], row['isLivingInIndia'])}"></mat-row>
        </div>


      </mat-table>

    </div>

    <!-- InActive&&MMSerious -->

    <div class="mat-elevation-z8-default" *ngIf="grid2==='inActiveMMSerious' || type==='paymentAuth'|| type==='search'"
      id='default-content'>
      <mat-table #table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter">

        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>

            <p *ngIf="col!='DisplayView'">{{ getHeader(col) }}</p>

          </mat-header-cell>
          <!-- matTooltip="{{element[col]}}" -->
          <mat-cell *matCellDef="let element;let j = index" class="ka-em-cell">
            <p *ngIf="col=== 'serial'"> {{j+1}} </p>
            <p>
              <span
                *ngIf="col!='SAForm' && col!='' && col!='PaymentDate' && col!='ProfileID' && col!='profileID'
                && col!='TicketName' && col!='ProfileDistype' && col!='PaidAmount' && col!='dob' && col != 'inactivaterequestby'">
                {{element[col]}}
              </span>
              <span *ngIf="col==='dob'">{{element[col]}}
                <span *ngIf="element['age']!=null">({{element['age']}})</span>
              </span>
              <span *ngIf="col === 'inactivaterequestby' && element['inactivaterequestby']===null">Customer</span>
              <span
                *ngIf="col === 'inactivaterequestby' && element['inactivaterequestby']!=null">{{element[col]}}</span>

              <span *ngIf="col==='ProfileID'" (click)="navigateToViewProfileByProfileId(element[col],element)"
                [ngStyle]="{'color': getAssignTicketColour('ProfileID', element)}">{{getProfileIdWithProfileTypes(col, element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
                  aria-hidden="true" style="color:black!important;cursor: pointer;"></i>

              </span>

              <span *ngIf="col==='profileID'" style="cursor: pointer;"
                [ngStyle]="{'color':getAssignTicketColour('profileID',element)}"
                (click)="navigateToViewProfileByProfileId(element[col],element)">{{getProfileIdWithProfileTypes(col, element)}}
                <span *ngIf="element?.kmplid && type !='keywordSearch'">({{element['kmplid']}})</span>
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileID'],$event)"
                  aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
              </span>

              <span *ngIf="col==='PaidAmount'" style="color: red; cursor: pointer;"
                (click)="navigateToPaymentPage(element['ProfileID'])">{{element[col]}}</span>

              <span *ngIf="col==='TicketName'" style="color: red; cursor: pointer;"
                (click)="viewTicket(element['TicketName'])">{{element[col]}}</span>

                <span *ngIf="col=='ticket'" style="color: red; cursor: pointer;"
                (click)="viewTicket(element['ticketID'])">{{element['ticketID']}}</span>

              <span *ngIf="col==='ProfileDistype' && element['noofcount']>0" style="color: red; cursor: pointer;"
                (click)="navigateToPaymentPage(element['ProfileID'])">{{element[col]}}
                <span>({{element['noofcount']}})</span></span>

              <span *ngIf="col==='ProfileDistype' && element['noofcount'] < 1">{{element[col]}}</span>


              <span *ngIf="col==='PaymentDate'">
                {{element[col] | date: 'd-MMM-y' }}
              </span>

              <!-- <span *ngIf="col==='SAForm' && element['SAForm']!=null && col!='DisplayView'"
                style="color: red; cursor: pointer;" (click)="viewSAFormWithPath(element['SAForm'])">
                SA FORM
              </span>

              <span *ngIf="col==='SAForm' &&  element['SAForm']===null && col!='DisplayView'" style="color: blue;">
                NO SA FORM
              </span> -->

              <span *ngIf="col==='DisplayView'" style="color: red;cursor: pointer;"
                (click)="openAuthrization(element,'auth')">Authorize
              </span>
              <span *ngIf="col==='DisplayView'" style="color: red;cursor: pointer;"
                (click)="openAuthrization(element,'decline')">Decline
              </span>

              <span *ngIf="col==='education'">{{element['educationGroup']}}</span>

              <span
                *ngIf="col!='SAForm' && col != 'education' && element[col]===null && col!='inactivaterequestby'">---</span>
            </p>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: defaultColumns;"
          [ngStyle]="{'background':changeRowColourSearchView(row['profileStatusID'], row['IsExpired'])}"></mat-row>

      </mat-table>

    </div>

    <div class="mat-elevation-z8-default" *ngIf="type == 'keywordSearch'"
    id='default-content'>
    <mat-table #table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter">

      <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; let i=index">
        <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>

          <p *ngIf="col!='DisplayView'">{{ getHeader(col) }}</p>

        </mat-header-cell>
        <!-- matTooltip="{{element[col]}}" -->
        <mat-cell *matCellDef="let element;let j = index" class="ka-em-cell" (click)="col!=='checkbox' ? navigateToViewProfileByProfileId(element['profileID'],element) : ''">
          <p *ngIf="col=== 'serial'"> {{j+1}} </p>


          <div *ngIf="col == 'checkbox'" >
            <mat-checkbox
            (change)="getCheckedProfile(element, $event); $event.stopPropagation()" [checked]="element.checked">
            </mat-checkbox>
          </div>

          <p>
            <span
              *ngIf="col!='SAForm' && col!='' && col!='PaymentDate' && col!='ProfileID' && col!='profileID'
              && col!='TicketName' && col!='ProfileDistype' && col!='PaidAmount' && col!='dob' && col != 'inactivaterequestby'">
              {{element[col]}}
            </span>
            <span *ngIf="col==='dob'">{{element[col]}}
              <span *ngIf="element['age']!=null">({{element['age']}})</span>
            </span>
            <span *ngIf="col === 'inactivaterequestby' && element['inactivaterequestby']===null">Customer</span>
            <span
              *ngIf="col === 'inactivaterequestby' && element['inactivaterequestby']!=null">{{element[col]}}</span>

            <span *ngIf="col==='ProfileID'" (click)="navigateToViewProfileByProfileId(element[col],element)"
              [ngStyle]="{'color': getAssignTicketColour('ProfileID', element)}">{{getProfileIdWithProfileTypes(col, element)}}
              <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>

            </span>

            <span *ngIf="col==='profileID'" style="cursor: pointer;"
              [ngStyle]="{'color':getAssignTicketColour('profileID',element)}"
              (click)="navigateToViewProfileByProfileId(element[col],element)">{{getProfileIdWithProfileTypes(col, element)}}
              <span *ngIf="element?.kmplid && type !='keywordSearch'">({{element['kmplid']}})</span>
              <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
            </span>

            <span *ngIf="col==='PaidAmount'" style="color: red; cursor: pointer;"
              (click)="navigateToPaymentPage(element['ProfileID'])">{{element[col]}}</span>

            <span *ngIf="col==='TicketName'" style="color: red; cursor: pointer;"
              (click)="viewTicket(element['TicketName'])">{{element[col]}}</span>

              <span *ngIf="col=='ticket'" style="color: red; cursor: pointer;"
              (click)="viewTicket(element['ticketID']); $event.stopPropagation()">{{element['ticketID']}}</span>

            <span *ngIf="col==='ProfileDistype' && element['noofcount']>0" style="color: red; cursor: pointer;"
              (click)="navigateToPaymentPage(element['ProfileID'])">{{element[col]}}
              <span>({{element['noofcount']}})</span></span>

            <span *ngIf="col==='ProfileDistype' && element['noofcount'] < 1">{{element[col]}}</span>


            <span *ngIf="col==='PaymentDate'">
              {{element[col] | date: 'd-MMM-y' }}
            </span>

            <!-- <span *ngIf="col==='SAForm' && element['SAForm']!=null && col!='DisplayView'"
              style="color: red; cursor: pointer;" (click)="viewSAFormWithPath(element['SAForm'])">
              SA FORM
            </span>

            <span *ngIf="col==='SAForm' &&  element['SAForm']===null && col!='DisplayView'" style="color: blue;">
              NO SA FORM
            </span> -->

            <span *ngIf="col==='DisplayView'" style="color: red;cursor: pointer;"
              (click)="openAuthrization(element,'auth')">Authorize
            </span>
            <span *ngIf="col==='DisplayView'" style="color: red;cursor: pointer;"
              (click)="openAuthrization(element,'decline')">Decline
            </span>

            <span *ngIf="col==='education'">{{element['educationGroup']}}</span>

            <span
              *ngIf="col!='SAForm' && col != 'education' && element[col]===null && col!='inactivaterequestby'">---</span>
          </p>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: defaultColumns;"
        [ngStyle]="{'background':changeRowColourSearchView(row['profileStatusID'], row['IsExpired'])}"></mat-row>

    </mat-table>

  </div>

    <div [hidden]=true>
      <mat-table #table matTableExporter [dataSource]="dataSource" matSort #hiddenExporter="matTableExporter"
        *ngIf="type==='profileAssign'">
        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>

            <p>{{ getHeader(col) }}</p>
          </mat-header-cell>

          <mat-cell *matCellDef="let element" class="ka-em-cell">

            <p *ngIf="element[col]!=null &&
          col != 'profileType' && col != 'ProfileID' &&  col != 'assign'" matTooltip="{{element[col]}}">
              {{element[col]}}</p>


            <p *ngIf="col == 'ProfileID'">
              <span
                [ngStyle]="{'color':getAssignTicketColour('ProfileID',element)}">{{getProfileIdWithProfileTypes(col,element)}}</span><br>
            </p>

            <p *ngIf="col == 'profileType' || col === 'ProfileOwnerID' || col=== 'ProfileSecondaryOwnerID' ||
          col === 'assign' || col === 'EnteredBy' ">
              null
            </p>

          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: defaultColumns;"></mat-row>

      </mat-table>
    </div>


  <div class="mat-elevation-z8-default" *ngIf="type==='commonTable' || type==='dontShowTable' || type1==='attendCustTable' || grid2==='duplicateData'"
      id='default-content'>
    <mat-table #table matTableExporter [dataSource]="dataSource" matSort>
      <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; let i=index">
        <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>

          <p>{{ getHeader(col) }}</p>
        </mat-header-cell>

        <mat-cell *matCellDef="let element" class="ka-em-cell">

          <p *ngIf="col!='actions' && col!='ProfileID' && col != 'profileid'" matTooltip="{{element[col]}}">
            {{element[col] | limitTo : '20'}}
          </p>
          <p *ngIf="col==='ProfileID' && col != 'profileid'" style="color: red;"
            [ngStyle]="{'color':getAssignTicketColour('profileID',element)}"
            (click)="navigateToViewProfileByProfileId(element['ProfileID'],element)">{{getProfileIdWithProfileTypes(col,element)}}
            <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
            aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
          </p>
          <p [ngStyle]="{'color':getAssignTicketColour('profileID',element)}" *ngIf="col === 'profileid'">
            {{getModifyProfileId(col,element)}}
            <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['profileid'],$event)"
            aria-hidden="true" style="color:black!important;cursor: pointer;"></i></p>

          <span *ngIf="col==='actions'" style="color: red; cursor: pointer;"
            (click)="updateDeleteOffice(element,'update')">Edit

          </span>
          <span *ngIf="col==='actions' && type1 !== 'attendCustTable'" style="cursor: pointer;"
            (click)="updateDeleteOffice(element,'delete')">Delete</span>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: defaultColumns;"
        [ngStyle]="{'background':changeRowColourEditViewValue(row?.ProfileStatusID)}"></mat-row>

    </mat-table>
  </div>


    <!----------------Market Reassign Grid------>
    <div class="mat-elevation-z8-default" *ngIf="type==='profileReAssign'" id='default-content'>
      <mat-table #table matTableExporter [dataSource]="dataSource" matSort #hiddenExporter="matTableExporter">
        <ng-container [matColumnDef]="col" *ngFor="let col of defaultColumns; trackBy: trackByFn;let i=index">
          <mat-header-cell class="ka-table-header" *matHeaderCellDef mat-sort-header>

            <p *ngIf="col != 'Chk'" >{{ getHeader(col) }}</p>
            <mat-checkbox *ngIf="col == 'Chk'" (change)="selectAllProfiles($event, dataSource)" [checked]="isProfileChecked"></mat-checkbox>
          </mat-header-cell>

          <mat-cell *matCellDef="let element" class="ka-em-cell">

            <p *ngIf="element[col]!=null &&
          col != 'profileType' && col != 'ProfileID' && col != 'profileID' &&  col != 'assign'" matTooltip="{{element[col]}}">
              {{element[col]}}</p>


            <p *ngIf="col == 'ProfileID' && col != 'profileID'" >
              <span
                [ngStyle]="{'color':getAssignTicketColour('ProfileID',element)}">{{getProfileIdWithProfileTypes(col,element)}}
                <i class="far fa-copy"  (click)="utilitiesService.copyProfileId(element['ProfileID'],$event)"
                aria-hidden="true" style="color:black!important;cursor: pointer;"></i>
</span><br>

              </p>

            <p *ngIf="col == 'profileID' && col != 'ProfileID'">
              <span
                [ngStyle]="{'color':getAssignTicketColour('profileID',element)}">{{getProfileIdWithProfileTypes(col,element)}}</span><br>
            </p>

            <p *ngIf="col == 'profileType' || col === 'ProfileOwnerID' || col=== 'ProfileSecondaryOwnerID' ||
          col === 'assign' || col === 'EnteredBy' ">
              null
            </p>

            <mat-checkbox *ngIf="col == 'Chk' && !autoMailGrid"
            (change)="checkedItem(element)" [checked]="element.checked">
            </mat-checkbox>

            <mat-checkbox *ngIf="col == 'Chk' && autoMailGrid"
            (change)="profilesSelected(element)" [checked]="element.isLowPriority">
            </mat-checkbox>

          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: defaultColumns;"></mat-row>

      </mat-table>
    </div>

    <!-- <app-profile-pagination [noOfRows]="totalRows" (sendPaginationBounds)='getPaginationBounds($event)'>
    </app-profile-pagination> -->
  </div>

  <div mdbModal #descriptionModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">

      <div class="modal-content">
        <p style="text-align: center; font-weight: bold;">Description</p>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="descriptionModal.hide()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row text-left">

          <!--Grid column-->
          <div class="col-md-12 rmSectionPopup">
            <div class="row p-2 m-2">

              <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                <p>{{descriptionMessage}}</p>

                <div class="action-buttons">
                  <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                    mdbWavesEffect type="submit" (click)="descriptionModal.hide()">close
                  </button>



                </div>

              </div>
            </div>

          </div>

          <!--Grid column-->
        </div>
      </div>
    </div>
  </div>


  <div mdbModal #adminModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="modal-content" style="border-radius: 0px !important;">
        <p style="text-align: center; font-weight: bold; background-color: lightgray;">Edit Payment Details</p>
        <button style="top: -12px !important" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="adminModal.hide()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row ka-em-admin-modal-content" [formGroup]="adminForm">

          <div class="col-md-6 rmSectionPopup">
            <label class="text-left ka-float-left ka-custom-margin-lable-bottom" for="agreedAmount">Enter
              Agreed Amount<span class="ka-em-requried">*</span></label>
            <input type="text" formControlName="agreedAmount" mdbInput class="form-control "
              placeholder="Enter Agreed Amount" (keypress)="omit_specialChar_and_char($event)">
            <div *ngIf="adminForm.controls['agreedAmount'].errors && !adminForm.controls['agreedAmount'].pristine "
              class="error-msg1">
              <div [hidden]="!adminForm.controls['agreedAmount'].errors.required">Agreed Amount is required.</div>
              <div [hidden]="!adminForm.controls['agreedAmount'].errors.pattern">
                Enter the Valid Agreed Amount
              </div>
            </div>

          </div>
          <div class="col-md-6 rmSectionPopup">
            <label class="text-left ka-float-left ka-custom-margin-lable-bottom" for="paidAmount">Enter
              Paid Amount<span class="ka-em-requried">*</span></label>
            <input type="text" formControlName="paidAmount" mdbInput class="form-control " placeholder="Enter profileID"
              (keypress)="omit_specialChar_and_char($event)" (focusout)="isAmountValid($event)">
            <div
              *ngIf="adminForm.controls['paidAmount'].errors && !adminForm.controls['paidAmount'].pristine && (isValidAmount===false) && (isGreaterAmount===false)"
              class="error-msg1">
              <div [hidden]="!adminForm.controls['paidAmount'].errors.required">Paid Amount is required.</div>
              <div [hidden]="!adminForm.controls['paidAmount'].errors.pattern">
                Enter the Valid Paid Amount
              </div>
            </div>
            <div *ngIf="isValidAmount===true" class="error-msg1">
              Paid amount should be less that Agreed Amount
            </div>
            <div *ngIf="isGreaterAmount===true" class="error-msg1">
              Paid amount should be less that {{balanceAmount}}
            </div>

          </div>
          <div class="col-md-12 rmSectionPopup">
            <label class="text-left ka-float-left " for="defaultContactFormName">Pay Description<span
                class="ka-em-requried">*</span></label>

            <textarea type="text" formControlName="paydescription" class="form-control" rows="2"
              placeholder="Enter message"></textarea>
            <div *ngIf="adminForm.controls['paydescription'].errors && !adminForm.controls['paydescription'].pristine "
              class="error-msg1">
              <div [hidden]="!adminForm.controls['paydescription'].errors.required">Pay Description is required.
              </div>
            </div>

          </div>

          <div class="action-buttons">
            <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
              type="submit" (click)="submitAdminForm()"
              [disabled]="(!adminForm.valid || isGreaterAmount ||isValidAmount)">submit
            </button>
          </div>




        </div>
      </div>
    </div>
  </div>

  <div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: false, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row text-left">

          <!--Grid column-->
          <div class="col-md-12 rmSectionPopup">
            <div class="row p-2 m-2">

              <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                <p class="mt-2 p-0">{{responseMessage}} </p>

                <div class="action-buttons">
                  <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                  </button>



                </div>

              </div>
            </div>

          </div>

          <!--Grid column-->



        </div>
      </div>
    </div>
  </div>

  <div mdbModal #updatePointsModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="modal-content" style="border-radius: 0px !important;" [formGroup]="updatePointsForm">
        <p style="text-align: center; font-weight: bold; background-color: red;padding: 2%;">Update Payment</p>
        <button style="top: -12px !important; color: black;" type="button" class="close" data-dismiss="modal"
          aria-label="Close" (click)="updatePointsModal.hide()">
          <span aria-hidden="true" class="">&times;</span>
        </button>
        <div class="row ka-em-update-modal-content">

          <div class="col-md-6 rmSectionPopup">
            <p *ngIf="formValue">
              ProfileId:<span style="cursor: pointer;" (click)="navigateToViewProfile()"
                [ngStyle]="{'color':getAdminProfileClr('profileID',formValue)}">{{adminProfileId}}</span>
            </p>
            <p>
              Expiry Date:<span>{{paymentExpiryDate}}</span>
            </p>
          </div>
        </div>
        <div class="col-md-12" style="padding-top: 0;">
          <label class="" style="padding-left:4px">Extended Days</label>
          <div class="button-holder-2">
            <input id="201" type="radio" class="regular-radio" value="20" name="extendedDays"
              formControlName="extendedDays">
            <label for="201">20-days</label>
            <input id="30" type="radio" class="regular-radio" value="30" name="extendedDays"
              formControlName="extendedDays">
            <label for="30">30-days</label>
            <input id="45" type="radio" class="regular-radio" value="45" name="extendedDays"
              formControlName="extendedDays">
            <label for="45">45-days</label>
          </div>
          <div class="error-msg1" *ngIf="isUpdatedPointsValue && updatePointsForm.value['extendedDays']===null">
            Extended Days are requried
          </div>
        </div>
        <div class="col-md-12">
          <label class="" style="padding-left: 4px;">Extended Points</label>
          <div class="button-holder-2">
            <input id="5" type="radio" class="regular-radio" value="5" name="exetendedPoints"
              formControlName="exetendedPoints">
            <label for="5">5-points</label>
            <input id="10" type="radio" class="regular-radio" value="10" name="exetendedPoints"
              formControlName="exetendedPoints">
            <label for="10">10-points</label>
            <input id="15" type="radio" class="regular-radio" value="15" name="exetendedPoints"
              formControlName="exetendedPoints">
            <label for="15">15-points</label>
            <input id="20" type="radio" class="regular-radio" value="20" name="exetendedPoints"
              formControlName="exetendedPoints">
            <label for="20">20-points</label>
          </div>
          <div class="error-msg1" *ngIf="isUpdatedPointsValue && updatePointsForm.value['exetendedPoints']===null">
            Points are requried
          </div>
        </div>

        <div class="row" style="justify-content: center">
          <div class="action-buttons">
            <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
              type="submit" (click)="submitPointsForm()" [disabled]="!updatePointsForm.valid">submit
            </button>
          </div>
        </div>


      </div>



    </div>
  </div>
  <!---------Confirm Modal-->
  <div mdbModal #confirmModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              (click)="confirmModal.hide()">
              <span aria-hidden="true" class="">&times;</span>
          </button>
          <div class="row text-left">

              <!--Grid column-->
              <div class="col-md-12 rmSectionPopup">
                  <div class="row p-2 m-2">

                      <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                          <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                          <p class="mt-2 p-0">{{responseMessage}} </p>

                          <div class="confirmModalbtns">
                              <button mdbBtn
                                  class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                  mdbWavesEffect type="submit" (click)="submitReassignData()">Submit
                              </button>

                              <button mdbBtn style="width:auto" (click)="confirmModal.hide()"
                                  mdbWavesEffect>cancel</button>

                          </div>

                      </div>
                  </div>

              </div>

              <!--Grid column-->



          </div>
      </div>
  </div>
  </div>

  <div mdbModal #brokerConfirmModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              (click)="brokerModal.hide()">
              <span aria-hidden="true" class="">&times;</span>
          </button>
          <div class="row text-left">

              <!--Grid column-->
              <div class="col-md-12 rmSectionPopup">
                  <div class="row p-2 m-2">

                      <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                          <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                          <div>Are you sure do you want to delete broker <span style="font-weight: bold;">{{brokerDetail?.name}}</span> ?</div>
                          <!-- <p class="mt-2 p-0">{{responseMessage}} </p> -->

                          <div class="confirmModalbtns">
                              <button mdbBtn
                                  class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                  mdbWavesEffect type="submit" (click)="deleteBrokerDetails()">yes
                              </button>

                              <button mdbBtn style="width:auto" (click)="brokerModal.hide()"
                                  mdbWavesEffect>cancel</button>

                          </div>

                      </div>
                  </div>

              </div>

              <!--Grid column-->



          </div>
      </div>
  </div>
  </div>
</div>

<app-sa-form *ngIf="saFormPhotoPath" [saForm]="saFormPhotoPath"></app-sa-form>

<div mdbModal #alertModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="alertModal.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
              <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
              <p class="mt-2 p-0">{{responseMessage}} </p>

              <div class="action-buttons">
                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
                  type="submit" (click)="alertModal.hide()">ok
                </button>



              </div>

            </div>
          </div>

        </div>

        <!--Grid column-->



      </div>
    </div>
  </div>
</div>

<div mdbModal #warningModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="dontAddProfileIdToList(toProfileIDAllData)">
        <span aria-hidden="true" class="">&times;</span>
      </button>
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
              <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
              <p class="mt-2 p-0 alertmsg" *ngFor="let message of alertMessage">
                {{message}} </p>
              <p style="font-size: 16px; font-weight: bold;">Do you want to continue ?</p>
            </div>
          </div>

        </div>

        <!--Grid column-->



      </div>
      <div class="row">
        <div class="col-md-6" style="text-align: end;">
          <div class="action-buttons">
            <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
              type="submit" (click)="getCheckedProfileAfterWarning(toProfileIDAllData)">Yes
            </button>
          </div>
        </div>


        <div class="col-md-6" style="text-align: start;padding-top: 2%;">
          <p style="padding-top: 5%;cursor: pointer;" (click)="dontAddProfileIdToList(toProfileIDAllData)"> <span>No</span>
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- <app-edit-view-slide-show *ngIf="isPlaySideShow" [mode]="mode" [formValue]="slideShowForm"
  (closeSlideShowModal)="closeSlideShowModal($event)"></app-edit-view-slide-show> -->
  <div mdbModal #reasonModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

      <div class="modal-content ka-modal">
           <h4 class="ka-popup-title">Export Records</h4>
            <form class="row text-left ka-excel-popup" [formGroup]="excelForm" (ngSubmit)="myProfileExportRecords()">
              <div class="form-group mr-3 ka-form-align">
                <label for="fromValue">From:</label>
                <input type="number" id="fromValue" class="form-control" formControlName = "fromValue" placeholder = "Enter From Value">
                <div *ngIf="excelForm.get('fromValue').invalid && excelForm.get('fromValue').touched" class="error-msg1">
                  From value is required
                </div>
              </div>
              <div class="form-group">
                <label for="toValue">To:</label>
                <input type="number" id="toValue" class="form-control" formControlName = "toValue" placeholder = "Enter To Value">
                <div *ngIf="excelForm.get('toValue').invalid && excelForm.get('toValue').touched" class="error-msg1">
                  To value is required
                </div>
              </div>
              <div class="row ka-err-msg reportErrorMessage error-msg1 mr-5" *ngIf="invalidDifference">
                {{exportRecordsErrMsg}}
              </div>
              <div class="form-actions ka-popup-btn">
                 <button type="submit" class="mr-2 btn ka-submit-clr" [disabled]="excelForm.invalid">Submit</button>
                <input type="reset" class="ka-reset-clr btn" value="Reset" (click)="resetForm()">
              </div>
              <div class="ka-popup-crossmrk">
                <span class="close-button" (click)="closeExcelDialog()">x</span>
              </div>
           </form>
          </div>
    </div>
  </div>
